<div class="container-fluid py-5 footer">
    <div class="row pt-4 justify-content-center">
        <div class="col">
            <span class="d-flex flex-column " style="gap:4rem">
                <span class="d-flex flex-column mainMargin" style="gap:2rem;">
                    <div class="row justify-content-start">
                        <img class="logo" src="../../../../assets/images/beyondi-logo-mint-white.svg" />
                    </div>
                    <div class="row justify-content-start">
                        <caption class="textMdNormal">
                            Created for every investor looking to access high quality
                            curated projects.
                        </caption>
                    </div>
                    <div class="row" hidden>
                        <div class="col-6">
                            <div class="row">
                                <div class="col pl-0">
                                    <p class="textMdMedium">Overview</p>
                                </div>
                                <div class="col">
                                    <p class="textMdMedium">Features</p>
                                </div>
                                <div class="col">
                                    <p class="textMdMedium">Pricing</p>
                                </div>
                                <div class="col">
                                    <p class="textMdMedium">Careers</p>
                                </div>
                                <div class="col">
                                    <p class="textMdMedium">Help</p>
                                </div>
                                <div class="col">
                                    <p class="textMdMedium">Privacy</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
                <span style="border-bottom: 1px solid #3D3D3D" class="mainMargin">

                </span>
                <span class="mainMargin ">
                    <div class="row">
                        <div class="col pl-0">
                            <p class="textMdNormal">© 2024 MTOS. All rights reserved.</p>
                        </div>
                        <div class="col-auto">
                            <div class="row">
                                <div class="col">
                                    <a class="mr-2" href="https://www.linkedin.com/company/beyondi"><i
                                            class="fa-brands fa-lg fa-linkedin brand"></i></a>
                                </div>
                                <div class="col">
                                    <a href="https://www.instagram.com/beyondi.bbd/"><i
                                            class="fa-brands fa-lg fa-instagram brand"></i></a>
                                </div>
                                <div class="col">
                                    <a href="https://www.instagram.com/beyondi.bbd/"><i
                                            class="fa-brands fa-lg fa-x-twitter brand"></i></a>
                                </div>
                                <div class="col">
                                    <a href="https://www.instagram.com/beyondi.bbd/"><i
                                            class="fa-brands fa-lg fa-github brand"></i></a>
                                </div>
        
                                <div class="col">
                                    <a href="https://www.instagram.com/beyondi.bbd/"><i
                                            class="fa-brands fa-lg fa-facebook brand"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
            </span>
            <!-- <div class="row"> -->
            <!-- <div class="row socialGroup py-4">
                <a class="mr-2" href="https://www.linkedin.com/company/beyondi"
                    ><i class="fa-brands fa-lg fa-linkedin brand"></i
                ></a>
                <a href="https://www.instagram.com/beyondi.bbd/"
                    ><i class="fa-brands fa-lg fa-instagram brand"></i
                ></a>
            </div> -->
            <!-- </div> -->
        </div>

        <!-- <div class="col about-lit ml-5">
            <div class="row">
                <h4>Token Sale</h4>
            </div>
            <div class="row">
                <p><a href="/tokenSale#howItWorks">How it works</a></p>
            </div>
            <div class="row">
                <p><a href="">Apply for IDO</a></p>
            </div>
        </div>
        <div class="col about-lit">
            <div class="row">
                <h4>About Beyondi</h4>
            </div>
            <div class="row">
                <p><a href="/about">About</a></p>
            </div>
            <div class="row">
                <p><a href="">Whitepaper</a></p>
            </div>
            <div class="row">
                <p><a href="contact">Contact us</a></p>
            </div>
        </div>
        <div class="col-lg-5 newsletter" *ngIf="mailchimpConfig">
            <div class="row">
                <div class="col-lg">
                    <h4 class="titleFooterMain">
                        Sign up to our newsletter and never miss a new project!
                    </h4>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    <input nbInput fullWidth placeholder="E-mail " id="email" fieldSize="small" type="email"
                        [(ngModel)]="email" />
                </div>
                <div class="col-3">
                    <input nbInput fullWidth placeholder="First name" fieldSize="small" type="text"
                        [(ngModel)]="firstName" />
                </div>
                <div class="col-3">
                    <input nbInput fullWidth placeholder="Last name" fieldSize="small" type="text"
                        [(ngModel)]="lastName" />
                </div>
                <div class="col-3 align-self-end">
                    <button nbButton status="primary" size="small" fullWidth (click)="subscribe()"
                        [disabled]="!email || !firstName || !lastName">
                        Subscribe
                    </button>
                </div>
            </div>
        </div> -->
    </div>
</div>